<template>
  <div>
    <div class="models-container">
      <div
        :class="[...manualClass, disableModelSelection && selectedModel !== 'manual' ? 'segmented-dim segmented-disabled-cursor' : '']"
        @click="!disableModelSelection && (selectedModel = 'manual')"
      >
        <div class="icon-text-row">
          <mf-icon>person_play</mf-icon>
          <span class="icon-label">Distribuição Manual</span>
        </div>
        <span class="description">
          Todos os clientes do segmento recebem todas as ofertas configuradas nesta campanha. Ex: se a campanha tem 50 produtos, cada cliente receberá todos
          esses 50 produtos.
        </span>
      </div>

      <div
        :class="[...intelligentClass, disableModelSelection && selectedModel !== 'intelligent' ? 'segmented-dim segmented-disabled-cursor' : '']"
        @click="!disableModelSelection && (selectedModel = 'intelligent')"
      >
        <div class="icon-text-row">
          <img :src="require('@/assets/icons/mar.ia-cor.svg')" alt="maria" />
          <span class="icon-label">Distribuição inteligente</span>
        </div>
        <span class="description">
          Cada cliente do segmento recebe apenas uma seleção específica de ofertas, escolhidas automaticamente pela inteligência artificial com base no seu
          perfil de compra. Ex: se a campanha tem 50 produtos, cada cliente recebe apenas 10 ofertas, de acordo com o perfil.
        </span>
      </div>
    </div>

    <template v-if="selectedModel === 'intelligent'">
      <div class="intelligent-config-container">
        <div class="config-section">
          <span class="field-label">Critérios de seleção de oferta</span>
          <h2 class="texto-corrido-destaque cinza-d10--text">Recompra</h2>
          <span class="d-block texto-corrido cinza-d10--text mb-4 mt-2">Produtos já comprados pelo usuário nos últimos 90 dias</span>
          <mf-number-input
            v-model="offersPerConsumer"
            :min="1"
            :max="20"
            show-arrows
            auto-format
            dense
            outlined
            placeholder="5"
            class="number-input"
            label="Quantidade de ofertas por recompra"
            :disabled="disableModelSelection"
            :error="!!offersPerConsumerErrors"
            :error-messages="offersPerConsumerErrors"
          />
          <span class="field-hint">Limite: 1-20 ofertas</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CampaignModelToggle',
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedModel: this.campaign.auto_distributed ? 'intelligent' : 'manual',
      offersPerConsumer: this.campaign.user_distribution_models?.[0]?.quantity || 1,
    }
  },
  computed: {
    disableModelSelection() {
      return ['finished', 'active', 'processing'].includes(this.campaign.status)
    },
    manualClass() {
      return ['segmented-base', this.selectedModel === 'manual' ? 'segmented-active' : 'segmented-inactive']
    },
    intelligentClass() {
      return ['nonsegmented-base', this.selectedModel === 'intelligent' ? 'nonsegmented-active' : 'nonsegmented-inactive']
    },
    offersPerConsumerErrors() {
      const val = this.validations?.campaign?.offers_per_consumer
      if (!val || !val.$dirty || !val.$error) return ''
      const errors = []
      if (!val.required) errors.push('Informe a quantidade de ofertas por consumidor.')
      if (!val.minValue) errors.push('A quantidade deve ser no mínimo 1.')
      if (!val.maxValue) errors.push('A quantidade deve ser no máximo 20.')
      return errors[0] || ''
    },
  },
  watch: {
    selectedModel(newModel, oldModel) {
      this.campaign.auto_distributed = newModel === 'intelligent'
      this.cleanupFieldsBasedOnModel(newModel)

      if (this.validations && this.validations.campaign && this.validations.campaign.auto_distributed && this.validations.campaign.auto_distributed.$touch) {
        this.validations.campaign.auto_distributed.$touch()
      }
    },
    offersPerConsumer(newValue) {
      if (!this.campaign.user_distribution_models) {
        this.$set(this.campaign, 'user_distribution_models', [])
      }
      if (this.campaign.user_distribution_models.length === 0) {
        this.campaign.user_distribution_models.push({ model: 'REPURCHASE', quantity: newValue })
      } else {
        this.campaign.user_distribution_models[0].quantity = newValue
      }

      if (
        this.validations &&
        this.validations.campaign &&
        this.validations.campaign.user_distribution_models &&
        this.validations.campaign.user_distribution_models.$touch
      ) {
        this.validations.campaign.user_distribution_models.$touch()
      }
    },
  },
  mounted() {
    this.cleanupFieldsBasedOnModel(this.selectedModel)
    this.$emit('register-validation', this.validateIntelligentConfig)
  },
  methods: {
    cleanupFieldsBasedOnModel(model) {
      if (model === 'manual') {
        if (this.campaign.hasOwnProperty('user_distribution_models')) {
          this.$delete(this.campaign, 'user_distribution_models')
        }
      } else if (model === 'intelligent') {
        if (!this.campaign.hasOwnProperty('user_distribution_models')) {
          this.$set(this.campaign, 'user_distribution_models', [{ model: 'REPURCHASE', quantity: this.offersPerConsumer }])
        }
      }
    },
    validateIntelligentConfig() {
      if (this.selectedModel === 'intelligent') {
        if (!this.offersPerConsumer || this.offersPerConsumer < 1 || this.offersPerConsumer > 20) {
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  margin-top: 24px;
}

.title {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #4b525a;
  margin-bottom: 20px;
}

.models-container {
  display: flex;
  justify-content: space-between;
}

.description {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #4b525a;
  margin-top: 4px;
}

.intelligent-config-container {
  margin-top: 20px;
}

.config-section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.field-label {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: $cinza-d10;
  margin-bottom: 24px;
}

.number-input {
  width: 298px;
}

.field-hint {
  display: block;
  font-size: 10px;
  font-weight: 400;
  color: #31363b;
  margin-bottom: 20px;
  margin-top: -20px;
}

.info-alert {
  margin-top: 16px;
}

.icon-text-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0px;
}

.icon-label {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #4b525a;
  margin-left: 8px;
}

.icon-text-row .v-icon {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.segmented-base {
  flex: 1;
  margin-top: 12px;
  padding: 12px 20px;
  border-style: solid;
  border-radius: 14px 0 0 14px;
  cursor: pointer;
}

.segmented-active {
  border-width: 2px !important;
  border-color: #0063c6 !important;
  background-color: #d2e9ff33 !important;
}

.segmented-inactive {
  border-width: 1px !important;
  border-color: #6b7580 !important;
  background-color: #fff !important;
}

.segmented-disabled-cursor {
  cursor: default !important;
}

.segmented-dim {
  opacity: 0.5 !important;
}

.nonsegmented-base {
  flex: 1;
  margin-top: 12px;
  padding: 12px 20px;
  border-style: solid;
  border-radius: 0 14px 14px 0;
  cursor: pointer;
}

.nonsegmented-active {
  border-width: 2px !important;
  border-color: #0063c6 !important;
  background-color: #d2e9ff33 !important;
}

.nonsegmented-inactive {
  border-width: 1px !important;
  border-color: #6b7580 !important;
  background-color: #fff !important;
}

.nonsegmented-disabled-cursor {
  cursor: default !important;
}

.nonsegmented-dim {
  opacity: 0.5 !important;
}

@media (max-width: 960px) {
  .models-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .segmented-base,
  .nonsegmented-base {
    width: 100%;
    border-radius: 14px;
    margin-top: 8px;
  }
}
</style>
